/**
 * useCensusRadioLayer — Wrapper de montaje para la capa de radios censales 2022.
 *
 * @remarks
 * Análogo a `useBuildingLayers`.
 * Solo activo cuando el módulo activo es 'urban' y hay projectId.
 * Lee visibilidad desde el store `useCensusRadioLayerStore`.
 */

import { useProject } from '../projects';
import { useModuleStore } from '../module-store';
import { useCensusRadioLayerStore } from './census-radio-layer-store';
import { useCensusRadioMapLayer } from './useCensusRadioMapLayer';

export function useCensusRadioLayer(): void {
  const { projectId }    = useProject();
  const { activeModule } = useModuleStore();
  const visible          = useCensusRadioLayerStore((s) => s.visible);
  const interactive      = useCensusRadioLayerStore((s) => s.interactive);

  const isUrban = activeModule === 'urban' && Boolean(projectId);

  useCensusRadioMapLayer({
    projectId:   projectId ?? '',
    visible:     isUrban && visible,
    interactive: isUrban && visible && interactive, // interactive requires visible
  });
}
